var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('landing-page-customization-container',{attrs:{"uri":_vm.uri},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isLoading = ref.isLoading;
var landingPageCustomization = ref.landingPageCustomization;
var errorCaught = ref.errorCaught;
return _c('div',{staticClass:"white-label-redemption-page"},[(errorCaught)?_c('redirect',{attrs:{"route-name":"Redeem"}}):(isLoading)?_c('white-label-printable-reward-link-redemption-page-loading'):_c('printable-reward-link-redemption-page',{attrs:{"landing-page-customization":landingPageCustomization}})],1)}}])})}
var staticRenderFns = []

export { render, staticRenderFns }